/**
 * NIKA: цената в бутона "Добави в количка" — "Добави в количка — 271,00 €".
 *
 * Цената се чете от продуктовата колона и се обновява при смяна на вариант
 * (темата морфва цената, затова следим нея, а пишем в бутона — различен
 * елемент, така няма цикъл).
 *
 * Отделен файл, зареден от theme.liquid: inline скрипт в morph-нат HTML
 * не се изпълнява.
 */
(function () {
  if (window.__nikaAtcPrice) return;
  window.__nikaAtcPrice = true;

  var PRICE_SEL = '.product-details product-price .price';
  /* NIKA ТЕСТ: бутонът живее и в дясната buy box колона */
  var BTN_SEL = '.product-details .add-to-cart-button, .product-details button[name="add"], .nika-buybox .add-to-cart-button, .nika-buybox button[name="add"]';

  var QTY_SEL = '.product-details quantity-selector-component input, .product-details .quantity-selector input, .nika-buybox quantity-selector-component input, .nika-buybox .quantity-selector input';
  var fmt = { format: function (n) { var p = Number(n).toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') + ',' + p[1] + '\u00A0€'; } };

  function priceText() {
    var el = document.querySelector(PRICE_SEL);
    if (!el) return '';
    /* махаме скритите за екранни четци надписи ("Цена при разпродажба") */
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach(function (n) {
      n.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  /* "4.271,00 €" → 4271.00 (в bg точката е разделител за хиляди) */
  function parsePrice(text) {
    var digits = text.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(digits);
    return isNaN(n) ? null : n;
  }

  function quantity() {
    var input = document.querySelector(QTY_SEL);
    var n = input ? parseInt(input.value, 10) : 1;
    return !n || n < 1 ? 1 : n;
  }

  /* "4.602,00" → "4 602,00" — интервал вместо точка за хиляди */
  function displayPrice(text) {
    return text.replace(/\.(?=\d{3})/g, '\u00A0');
  }

  /* при 1 брой показваме цената както е изписана; при повече — умножена */
  function labelPrice() {
    var text = priceText();
    if (!text) return '';
    var qty = quantity();
    if (qty <= 1) return displayPrice(text);
    var unit = parsePrice(text);
    return unit === null ? displayPrice(text) : fmt.format(unit * qty);
  }

  function apply() {
    var price = labelPrice();
    document.querySelectorAll(BTN_SEL).forEach(function (btn) {
      if (btn.disabled) return; /* изчерпан → без цена */
      var label = btn.querySelector('.add-to-cart-text') || btn.querySelector('.nika-atc-label');
      if (!label) {
        /* Tinker: текстът на бутона е гол текстов възел в flex бутон. Ако цената
           е отделен flex елемент, на тесен екран (мобилно, до количеството) двата
           се чупят на 2+3 реда. Обвиваме текста, цената влиза в същия inline поток. */
        var node = null;
        for (var i = 0; i < btn.childNodes.length; i++) {
          var c = btn.childNodes[i];
          if (c.nodeType === 3 && c.textContent.trim()) { node = c; break; }
        }
        if (!node) return;
        label = document.createElement('span');
        label.className = 'nika-atc-label';
        label.textContent = node.textContent.trim();
        btn.replaceChild(label, node);
      }
      var slot = label.querySelector('.nika-atc-price');
      if (!price) {
        if (slot) slot.remove();
        return;
      }
      if (!slot) {
        slot = document.createElement('span');
        slot.className = 'nika-atc-price';
        label.appendChild(slot);
      }
      var text = ' — ' + price;
      if (slot.textContent !== text) slot.textContent = text;
    });
  }

  var pending = null;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(apply, 60);
  }

  function watch() {
    var host = document.querySelector('.product-details');
    if (!host) return;
    /* следим цената; пишем в бутона → няма самозадействане */
    new MutationObserver(schedule).observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /* промяната на количеството НЕ прави DOM мутация → слушаме събитията.
     Бутоните +/- също минават през input/change на полето. */
  ['input', 'change', 'click'].forEach(function (ev) {
    document.addEventListener(
      ev,
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('.product-details quantity-selector-component, .product-details .quantity-selector, .nika-buybox quantity-selector-component, .nika-buybox .quantity-selector')) schedule();
      },
      true
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      apply();
      watch();
    });
  } else {
    apply();
    watch();
  }
})();
